import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'
import {Nav, Navbar, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'

const Styles = styled.div `

    // - - NAVBAR - - //

.theNavbar {
    max-width: 95%;
}

.logo {
    font-family: Val;
    color: #99CC63;
    font-size: 30px;
    margin-left: 2%;
    cursor: pointer;
}

.logo:hover {
    color: #724E39;
}

.linkItem {
    max-width: 100%;
    margin-right: 15%;
    }

    // - - NAVBAR LINKS - - //

.navLinks {
    margin-right: 15%;
    color: #FF3C33;
    font-size: 20px;
    font-family: DM Sans;
}

.linkItem {
    margin-right: 50%;
}

.linkItem label {
    color: #99CC63;
    cursor: pointer;
}

.linkItem label:hover {
    color: #724E39;
}

    // - - HEADER - - //

.header {
    text-align: center;  
    margin-top: 5%; 
}

.header h1 {
    font-family: DM Sans;
}

    // - - LOGIN DIV - - //

.loginDiv {
    border-radius: 10px;
    text-align: center;
    border: 4px solid #99CC63;
    margin-left: 25%;
    margin-right: 25%;
}

.loginDiv input {
    text-align: center;
    margin-top: 3%;
    width: 40%;
    height: 37.5px;
    border: 0.5px solid black;
    border-radius: 8px;
    outline: none;
    padding: 6px;
    font-family: DM Sans;
}

.loginDiv p {
    margin-top: 1.5%;
    margin-bottom: 3%;
    font-family: DM Sans;
}

.loginDiv button {
    padding: 0.75%;
    width: 150px;
    background-color: #99CC63;
    color: white;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-family: DM Sans;
    font-size: 17.5px;
    cursor: pointer;
    margin-bottom: 2%;
    outline: none;
}

    // - - LOGIN ELEMENTS - - //

.loginElements {
    margin-top: 5%;
    margin-bottom: 5%;
}

    // - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {

        // - - NAVBAR LINKS - - //

    .linkItem label {
        margin-left: 5%;
    }
    

        // - - HEADER - - //


        // - - LOGIN DIV - - //

    .loginDiv {
        margin-top: 20%;
        margin-left: 5%;
        margin-right: 5%;
    }

    .loginDiv p {
        margin-top: 5%;
    }

    .loginDiv input {
        width: 90%;
    }

    .loginDiv button {
        padding: 2%;
        width: 50%;
        margin-top: 3.5%;
    }
}


`

export default class Login extends Component {
    constructor(){
        super()
        this.state = {
            email: "",
            emailErrMsg: "",
            password: "",
            passwordErrMsg: "",
            showLogin: true,
            showSignUp: false,
            firstName: "",
            firstnameErrMsg: "",
            lastName: "",
            lastnameErrMsg: "",
            emailSignUp: "",
            passwordSignUp: "",
            confirmPassword: ""
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }
 
    loginClicked = () => {
        if (this.state.email == "" && this.state.password == "") {
            this.setState({
                emailErrMsg: "Please enter your email",
                passwordErrMsg: "Please enter a password"
            })
        } else if (!this.state.email == "" && this.state.password == "") {
            this.setState({
                emailErrMsg: "",
                passwordErrMsg: "Please enter your password"
            })
        } else if (this.state.email == "" && !this.state.password == "") {
            this.setState({
                emailErrMsg: "Please enter your email",
                passwordErrMsg: ""
            })
        } else {
            this.setState({
                emailErrMsg: "",
                passwordErrMsg: ""
            })
            fire.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then((u)=>{
                localStorage.setItem('logged', true)
                window.location.href = '/home'
            }).catch((error)=>{
                this.setState({
                    passwordErrMsg: error.toString()
                })
            })
        }
    }

    signUpClicked = () => {
        if (!this.state.firstName == "" &&
            !this.state.lastName == "" &&
            !this.state.emailSignUp == "" && 
            !this.state.passwordSignUp == "" && 
            !this.state.confirmPassword == "") {
                if (this.state.passwordSignUp === this.state.confirmPassword) {
                    // Sign Up Go Through
                    this.setState({
                        firstnameErrMsg: "",
                        lastnameErrMsg: "",
                        emailErrMsg: "",
                        passwordErrMsg: ""
                    })
                    fire.auth().createUserWithEmailAndPassword(this.state.emailSignUp, this.state.passwordSignUp)
                    .then((user) => {
                        window.location.href = '/home'
                    })
                    .catch((error) => {
                        this.setState({
                            passwordErrMsg: error.toString()
                        })
                    });
                } else {
                    this.setState({
                        passwordErrMsg: "Passwords do not match"
                    })
                }

            } else {
                this.setState({
                    passwordErrMsg: "Please fill out all information above"
                }) 
                
            }
    }

    createAccountClicked = () => {
        this.setState({
            showLogin: false,
            showSignUp: true,
            emailErrMsg: "",
            passwordErrMsg: ""
        })
    }

    backToLogin = () => {
        this.setState({
            showLogin: true,
            showSignUp: false,
            emailErrMsg: "",
            passwordErrMsg: "",
            firstnameErrMsg: "",
            lastnameErrMsg: ""
        })
    }

    render () {
        return(
            <Styles>
                <Navbar expand="lg" className="theNavbar">
                    <Navbar.Brand className='logo' href="/">Salis</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="navLinks ms-auto">
                        <Nav.Link className="linkItem" href="/" ><label><strong>Home</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/sell" ><label>Home</label></Nav.Link> */}
                        {/* <Nav.Link className="linkItem" href="/donate" ><label>Donate</label></Nav.Link> */}
                        {/* <Nav.Link className="linkItem" href="/login" ><label>Login</label></Nav.Link> */}
                    </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <div className='header'>
                    {/* <h1>Login</h1> */}
                </div>
                {this.state.showLogin && 
                <div className='loginDiv'>
                    <div className='loginElements'>
                        <input
                        id="email"
                        placeholder='Email'
                        value={this.state.email}
                        onChange={this.handleChange}
                        />
                        <p>{this.state.emailErrMsg}</p>
                        <input
                        id="password"
                        type='password'
                        placeholder='Password'
                        value={this.state.password}
                        onChange={this.handleChange}
                        />
                        <p>{this.state.passwordErrMsg}</p>
                        <button
                        onClick={this.loginClicked}
                        >Login</button><br/>
                        <button
                        onClick={this.createAccountClicked}
                        >Create Account</button>
                    </div>
                </div>
                }
                {this.state.showSignUp && 
                    <div className='loginDiv'>
                        <div className='loginElements'>
                            <input
                            id="firstName"
                            placeholder='Enter first name'
                            value={this.state.firstName}
                            onChange={this.handleChange}
                            />
                            <p>{this.state.firstnameErrMsg}</p>
                            <input
                            id="lastName"
                            placeholder='Enter last name'
                            value={this.state.lastName}
                            onChange={this.handleChange}
                            />
                            <p>{this.state.lastnameErrMsg}</p>
                            <input
                            id="emailSignUp"
                            placeholder='Email'
                            value={this.state.emailSignUp}
                            onChange={this.handleChange}
                            />
                            <p>{this.state.emailErrMsg}</p>
                            <input
                            id="passwordSignUp"
                            type='password'
                            placeholder='Password'
                            value={this.state.passwordSignUp}
                            onChange={this.handleChange}
                            />
                            <p>{this.state.emailErrMsg}</p>
                            <input
                            id="confirmPassword"
                            type='password'
                            placeholder='Confirm Password'
                            value={this.state.confirmPassword}
                            onChange={this.handleChange}
                            />
                            <p>{this.state.passwordErrMsg}</p>
                            <button
                            onClick={this.signUpClicked}
                            >Create Account</button><br/>
                            <button
                            onClick={this.backToLogin}
                            >Back</button>
                        </div>
                    </div>
                }
                
            </Styles>
        )
    }
}